import React, { useEffect, useState } from "react";
import { Volume2, VolumeX, Loader2 } from "lucide-react";
import { speak, stopSpeaking, isSpeechSupported } from "@/lib/voice";

/**
 * Male-voice playback button for a single chatbot reply.
 * Uses Web Speech API — free, no API key. French male voice preferred.
 *
 * Props:
 *  - text: the message string to read
 *  - lang: "fr" | "en"
 *  - accent: CSS color for the active state
 *  - testId: data-testid for the toggle button
 */
export default function VoiceButton({ text, lang = "fr", accent = "#c8f76c", testId }) {
  const [speaking, setSpeaking] = useState(false);
  const supported = isSpeechSupported();

  useEffect(() => {
    return () => stopSpeaking();
  }, []);

  const toggle = () => {
    if (speaking) {
      stopSpeaking();
      setSpeaking(false);
      return;
    }
    setSpeaking(true);
    speak(text, { lang, onEnd: () => setSpeaking(false) });
  };

  if (!supported) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testId}
      title={speaking ? (lang === "fr" ? "Arrêter" : "Stop") : (lang === "fr" ? "Écouter" : "Listen")}
      className="inline-flex items-center justify-center w-[30px] h-[26px] rounded-lg transition-all"
      style={{
        background: speaking ? `${accent}38` : "rgba(255,255,255,0.06)",
        border: `1px solid ${speaking ? accent + "aa" : "rgba(255,255,255,0.16)"}`,
        color: speaking ? accent : "rgba(255,255,255,0.7)",
      }}
    >
      {speaking ? <Loader2 size={12} className="animate-spin" /> : <Volume2 size={12} />}
    </button>
  );
}
